var _defs, _path;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgBloco = function SvgBloco(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11.917,
    height: 13,
    viewBox: "0 0 11.917 13",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#a8b1bf;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M702.863,378.071h-5.417a3.254,3.254,0,0,0-3.25,3.25v5.416a3.253,3.253,0,0,0,3.25,3.25h.842a2.149,2.149,0,0,0,3.733,0h.842a3.253,3.253,0,0,0,3.25-3.25v-5.416A3.253,3.253,0,0,0,702.863,378.071Zm1.951,8.666a1.953,1.953,0,0,1-1.951,1.951H702.3a2.155,2.155,0,0,0-4.29,0h-.563a1.952,1.952,0,0,1-1.95-1.951v-5.416a1.952,1.952,0,0,1,1.95-1.95h5.417a1.952,1.952,0,0,1,1.951,1.95Z",
    transform: "translate(-694.196 -378.071)"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgBloco, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/bloco.e86e8ff0.svg";
export { ForwardRef as ReactComponent };